import { jsx as r } from "react/jsx-runtime";
import { forwardRef as h } from "react";
import { styledWithConfig as t } from "./utils.js";
const f = {
  a: t("a"),
  div: t("div"),
  h1: t("h1"),
  h2: t("h2"),
  h3: t("h3"),
  h4: t("h4"),
  h5: t("h5"),
  button: t("button"),
  p: t("p"),
  span: t("span"),
  label: t("label"),
  form: t("form"),
  input: t("input")
}, l = h((o, n) => {
  const {
    component: a = "div",
    children: e,
    dataNoTranslate: s,
    dataTest: i,
    customComponent: c,
    UNSAFE_role: m,
    UNSAFE_ariaChecked: p,
    ...u
  } = o, d = c ? a : f[a];
  return /* @__PURE__ */ r(
    d,
    {
      ref: n,
      ...u,
      ...{
        "data-notranslate": s,
        "data-test": i
      },
      ...{
        role: m,
        "aria-checked": p
      },
      children: e
    }
  );
});
function v(o) {
  const n = t(
    o
  );
  return function(e) {
    return /* @__PURE__ */ r(l, { ...e, customComponent: !0, component: n });
  };
}
export {
  l as default,
  v as makeBox
};
